import {type TPandasTable} from '../models/TPandasTable';
import type React from 'react';

export default function addCustomTableColumn(
    pandasTable: TPandasTable | undefined,
    columnName: string,
    renderCell: (rowIndex: number, rowArray: React.ReactNode[]) => React.ReactNode
): TPandasTable {
  if (pandasTable === undefined) return {};

  const rowCount = Object.values(Object.values(pandasTable)[0] ?? {}).length;

  const newColumn: Record<number, React.ReactNode> = {};
  for (let ix = 0; ix < rowCount; ix++) {
    // pass the entire row as ReactNodes array so cell can depend on other values if needed
    const rowArray = Object.values(pandasTable).map((col) => col[ix]);
    newColumn[ix] = renderCell(ix, rowArray);
  }

  return {
    ...pandasTable,
    [columnName]: newColumn, // add as new column
  };
}